import React from "react";

export const CareCommentAnalysisDataTableHead = React.memo(function CareCommentAnalysisDataTableHead() {
    return (
        <thead>
            <tr>
                <th>No.</th>
                <th>登録日時</th>
                <th>ハウスID</th>
                <th>登録コメント</th>
                <th>登録回数</th>
                <th>ユーザー名</th>
                <th>アドレス</th>
                <th>カテゴリ</th>
                <th>開封日時</th>
            </tr>
        </thead>
    );
});
